import { forwardRef } from 'react';
import { CardProps } from './types';
import clsx from 'clsx';
import { styleCard } from './style';

/**
 *  UI Component
 */
const Card = forwardRef<HTMLDivElement, CardProps>(function Card(props, ref) {
  // Apply Default props values
  props = {
    ...{
      rounded: true,
      raised: true,
      padding: 'normal',
      seperated: true,
      bgColor: 'default'
    },
    ...props
  };

  const {
    className,
    children,
    raised,
    rounded,
    seperated,
    padding,
    bgColor,
    outlined,
    ...rest
  } = props;

  const cls = styleCard(props);
  return (
    <div className={clsx(cls.main, className)} ref={ref} {...rest}>
      {children}
    </div>
  );
});

export default Card;
